import { render, staticRenderFns } from "./AccountingMenu.vue?vue&type=template&id=dfab213e&scoped=true"
import script from "./AccountingMenu.vue?vue&type=script&lang=js"
export * from "./AccountingMenu.vue?vue&type=script&lang=js"
import style0 from "./AccountingMenu.vue?vue&type=style&index=0&id=dfab213e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfab213e",
  null
  
)

export default component.exports